<div class="flex">
    <label [title]="caption()" [for]="caption()">{{caption()}}</label>
    @if (isRequired && isEnabled) {
        <span class="required">*</span>
    }
</div>
